module.exports = __webpack_public_path__ + "static/tutorial3-3aacb34bec4ab71339cd5fec3a698ff8.png";